export default {
  // Sider
  country: 'Select country',
  personalInfo: 'Personal information',
  createPassword: 'Create password',
  companyAddress: 'Company address',
  companyInformation: 'Company information',
  createAccount: 'Create account',
  // Select country
  countryHeader: 'Create new business account',
  countrySubtitle: 'Fast and free sign-up for {{brandingName}} Business Service',
  countryInputPlaceholder: 'Country of Business Residence',
  getStarted: 'Get started',
  signIn: 'Have an account? Sign in.',
  // Personal Information
  personalInfoHeader: 'Personal Information',
  personalInfoSubtitle: 'Enter your contact information to start enrollment.',
  'terms and conditions': 'terms and conditions',
  'I agree with <1>{{name}}<1/>': 'I agree with <1>{{name}}<1/>.',
  // confirmPhone
  confirmPhoneHeader: 'Confirm your phone number',
  confirmPhoneSubtitle: 'Please enter one-time code delivered by SMS to',
  confirmPhoneInputPlaceholder: 'One-time code',
  wrongOtp: 'Wrong one-time code',
  // Authenticate with password
  'Authenticate with password': 'Authenticate with password',
  'Enter password for {{email}}': 'Enter password for {{email}}',
  Password: 'Password',
  // Create password
  createPasswordHeader: 'Create password',
  createPasswordSubtitle: 'Password shall contain at least {{passwordMinLength}} symbols.',
  // Company information
  companyInformationHeader: 'Company information',
  companyInformationSubtitle: 'Please share basic details about your company.',
  // Company contacts
  'Company contacts': 'Company contacts',
  'Please fill company contacts': 'Please fill company contacts',
  'Company phone number': 'Company phone number',
  'Company email': 'Company email',
  // Company address
  companyAddressHeader: 'Company address',
  companyAddressSubtitle: 'Fill company official address.',
  // Create account
  lastStep: 'Last step!',
  leaveYourEmail: 'Please leave your email. It will be used as login',
  confimEmail: 'Confirm your email',
  enterEmailOtp: 'Please enter one-time code delivered to your email',
  // Already exist
  accountExist: 'Account exist',
  accountExistHeader: 'Account already exists',
  accountExistSubtitle:
    "And you are already have business related to your account. It's nothing to register, so log in.",
  startFromBegining: 'Start from the beginning?',
  changesWillLost: 'Changes you made will be lost. Confirm to proceed.',
  // Document fields
  number: 'Number',
  dateOfIssue: 'Date of issue',
  dateOfExpiry: 'Date of expiry',
  establishmentDate: 'Establishment date',
};
